 /*eslint-disable */
 // selectors
 export const selectUserActivitiesArray = (state) => state.userActivities.userActivities?.logEvents

 export const selectTotalUserActivitiesCount = (state) => state.userActivities.userActivities?.totalRecordsMatched

 export const selectUserActivitiesStatus = (state) => state.userActivities.status

 export const selectUserActivitiesError = (state) => state.userActivities.error

